export const LANGUAGES = {
    GE: 'ge',
    EN: 'en',
    RU: 'ru',
    UA: 'ua',
};

export const SUPPORTED_LANGS = ['ge', 'ru', 'en', 'ua'];

export const HTML_LANG_MAP = {
    ge: 'ka',
    ua: 'uk',
    en: 'en',
    ru: 'ru',
};

export const isSupportedLang = (lang) => SUPPORTED_LANGS.includes(lang);

export const stripLangPrefix = (path) => {
    if (typeof path !== 'string' || !path) return path;
    const segments = path.split('/').filter(Boolean);
    if (segments.length && isSupportedLang(segments[0])) {
        return `/${segments.slice(1).join('/')}`;
    }
    return path;
};
